import React, { useContext } from 'react'
import styled from 'styled-components'
import './assets/widget-icon.scss'
import { DashboardContext } from 'live/context/dashboard'
import Highcharts from 'highcharts'

const Wrapper = styled.div`
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    display: grid;
    grid-template-rows: auto;
    height: 100%;
    align-content: space-around;

    h3 {
        font-size: 10px;
        line-height: 12px;
        color: var(--gray-700);
        width: fit-content;
    }

    p {
        font-size: 24px;
        line-height: 24px;
        color: var(--gray-800);
        width: fit-content;
        margin-bottom: 0px;
        span {
            font-size: 16px;
            margin-left: 4px;
        }
    }

    .columns {
        display: grid;
        grid-template-columns: 50% 50%;
    }

    .optimum_flow {
        border: 1px solid var(--green-700);
        padding: 8px;
        border-radius: 3px;
        margin-bottom: 8px;
        p {
            margin: auto;
        }
    }

    .card_values {
        div {
            display: flex;
            flex-flow: column;
            width: fit-content;
            max-width: 100%;
            overflow: hidden;
        }
    }
`

// const values = {
//   realTime: 236.26,
//   model: 180,
//   optimumFlow: 495,
//   uom: "gpm",
// }

const checkValue = (values, property) => (values ? values[property] ?? null : null)

export default (props: any) => {
    const { ...context } = useContext(DashboardContext)
    const { values } = props

    return (
        <Wrapper theme={context.theme}>
            {values?.optimumFlow !== undefined && (
                <div className="columns optimum_flow">
                    <h3>
                        {values?.title ? values?.title?.toUpperCase() : 'OPTIMUM FLOW RATE FOR EFFICIENT HOLE CLEANING'}
                    </h3>
                    <p>
                        {checkValue(values, 'optimumFlow')}
                        <span>{checkValue(values, 'uom')}</span>
                    </p>
                </div>
            )}
            <div className="columns card_values">
                <div>
                    <h3>REAL-TIME</h3>
                    <p>
                        {checkValue(values, 'realTime')}
                        <span>{checkValue(values, 'uom')}</span>
                    </p>
                </div>
                <div>
                    <h3>MODEL</h3>
                    <p>
                        {checkValue(values, 'model')}
                        <span>{checkValue(values, 'uom')}</span>
                    </p>
                </div>
            </div>
        </Wrapper>
    )
}
